var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_exe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_exe",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "exe",
    d: "M3371.8,7162H3359v-16h8.229v4.7h4.571V7162Zm-7.3-6.744h-.751l1.134,1.856-1.16,1.888h.755l.808-1.372h0l.8,1.372h.758l-1.156-1.888,1.13-1.856h-.751l-.785,1.354Zm2.831,0V7159h2.448v-.52h-1.8v-1.152h1.537v-.514h-1.537v-1.033h1.779v-.525Zm-6.311,0V7159h2.448v-.52h-1.8v-1.152h1.539v-.514h-1.539v-1.033h1.779v-.525Zm10.644-5.491h-3.521v-3.625l3.52,3.624Z",
    transform: "translate(-1922.4 -7129.002)",
    fill: "#08232f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExe);
export default __webpack_public_path__ + "static/media/ic_exe.eaab6ba461f30d770fbc291cd7fc02f3.svg";
export { ForwardRef as ReactComponent };